module.exports = __webpack_public_path__ + "media/images/icon_good-c60037218afefcc76cc4be25b12df153.png";